import React, { FC } from "react";

import { useTranslation } from "react-i18next";

type MonthFormatProps = {
    month: number;
};

const MonthFormat: FC<MonthFormatProps> = ({ month }) => {
    const { t } = useTranslation();
    let result = "";
    if (!isNaN(month)) {
        result = {
            0: t("Months.1"),
            1: t("Months.2"),
            2: t("Months.3"),
            3: t("Months.4"),
            4: t("Months.5"),
            5: t("Months.6"),
            6: t("Months.7"),
            7: t("Months.8"),
            8: t("Months.9"),
            9: t("Months.10"),
            10: t("Months.11"),
            11: t("Months.12"),
        }[month];
    }
    return <>{result}</>;
};

export default MonthFormat;
